import { defineStore } from 'pinia'
import {
  type StatusState,
  statusInitialState
} from '@/status/core/domain/StatusState'
import { clone } from '@/shared/utils/clone'

export const useStatusStore = defineStore('status', {
  state: (): StatusState => clone(statusInitialState)
})
